<template>
  <!-- Add/Edit Modal -->
  <div
    class="modal fade"
    id="add_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <!-- Added 'modal-md' for medium size -->
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? "Update" : "Create" }} {{ title }}
          </h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- File Name Input -->
            <div class="mb-3">
              <label class="col-form-label" for="file_name"
                >File Name <span class="text-danger">*</span></label
              >
              <input
                type="text"
                name="file_name"
                id="file_name"
                class="form-control"
                v-model="file_name"
              />
              <div class="text-danger" v-if="errors.file_name">
                {{ errors.file_name[0] }}
              </div>
            </div>

            <!-- Category Selection -->
            <div class="mb-3">
              <label class="col-form-label"
                >Category <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedCategory"
                :options="categories"
                track-by="id"
                label="name"
                placeholder="Select a category"
              />
              <div class="text-danger" v-if="errors.category_id">
                {{ errors.category_id[0] }}
              </div>
            </div>

            <!-- Exhibitions Selection -->
            <div class="mb-3">
              <label class="col-form-label"
                >Exhibitions <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedExhibition"
                :options="exhibitions"
                track-by="id"
                label="name"
                placeholder="Select a category"
              />
              <div class="text-danger" v-if="errors.exhibition_id">
                {{ errors.exhibition_id[0] }}
              </div>
            </div>

            <!-- Document Upload and Preview Section -->
            <div class="mb-3">
              <label class="col-form-label">Documents</label>
              <input
                type="file"
                multiple
                class="form-control"
                id="document_files"
                name="document_files"
                @change="handleFileUpload($event)"
              />
              <div class="text-danger" v-if="errors.document_files">
                {{ errors.document_files[0] }}
              </div>
              <div class="text-danger" v-if="errors.files">
                {{ errors.files[0] }}
              </div>

              <div class="d-flex flex-wrap gap-3 mt-2">
                <div
                  v-for="(file, index) in document_files"
                  :key="index"
                  class="file-preview text-center"
                >
                  <!-- Preview: Image or Default File Name -->
                  <div class="preview-box">
                    <img
                      v-if="isImage(file)"
                      :src="file?.preview"
                      alt="File Preview"
                      class="img-thumbnail"
                    />

                    <!-- Show static preview for Word or PDF -->
                    <img
                      v-else-if="isPdf(file)"
                      src="@/assets/img/pdf-icon.jpg"
                      alt="PDF File"
                      class="static-thumbnail"
                    />
                    <img
                      v-else-if="isWord(file)"
                      src="@/assets/img/word-icon.jpg"
                      alt="Word File"
                      class="static-thumbnail"
                    />
                    <img
                      v-else-if="isExcel(file)"
                      src="@/assets/img/excel-icon.jpg"
                      alt="Excel File"
                      class="static-thumbnail"
                    />

                    <!-- Show file name if it's not an image, Word, or PDF -->
                  </div>
                  <div class="file-name">
                    {{ getFileName(file.file_path) }}
                  </div>

                  <!-- File download button -->
                  <button
                    type="button"
                    class="btn btn-primary btn-sm mt-2 p-0"
                    @click="removeFile(index)"
                    v-if="file?.preview"
                  >
                    remove
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                {{ isEditMode ? "Update" : "Create" }}
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm ms-2"
                ></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i class="ti ti-trash-x fs-36 text-danger"></i>
            </div>
            <h4 class="mb-2">Remove {{ title }}?</h4>
            <p class="mb-0">Are you sure you want to remove it</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                class="btn btn-danger"
                @click="deleteItem()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    file_name: "",
    document_files: [],
    category_id: null,
    exhibition_id: null,
    selectedCategory: null,
    selectedExhibition: null,
    itemId: null,
    errors: {},
    categories: [],
    exhibitions: [],
  }),
  watch: {
    selectedCategory(newValue) {
      this.category_id = newValue?.id;
    },
    selectedExhibition(newValue) {
      this.exhibition_id = newValue?.id;
    },
  },
  mounted() {
    this.getCategories();
    this.getExhibitions();
    this.$emitter.on("add-edit-item", (row) => {
      if (row) {
        this.itemId = row.id;
        this.file_name = row?.file_name;
        this.selectedCategory = {
          id: row?.category?.id,
          name: row?.category?.name,
        };
        this.selectedExhibition = {
          id: row?.exhibition?.id,
          name: row?.exhibition?.name,
        };

        this.fetchExistingFiles(row);
      }

      this.$handleModal("add_item", "toggle");
    });

    this.$emitter.on("delete-item-modal", (row) => {
      if (row) {
        this.itemId = row.id;
      }
      this.$handleModal("delete_item", "toggle");
    });
  },

  methods: {
    async getCategories() {
      const endpoint = `/document-categories`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.categories = response.data.contents.map((category) => ({
          id: category.id,
          name: category.name,
        }));
      } catch (error) {
        //
      }
    },
    async getExhibitions() {
      const endpoint = `/exhibitions`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.exhibitions = response.data.contents.map((exhibition) => ({
          id: exhibition.id,
          name: exhibition.name,
        }));
      } catch (error) {
        //
      }
    },

    // Handle file upload for new files
    handleFileUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          this.document_files.push({
            file: file,
            preview: e.target.result,
            name: file.name,
            file_path: file.name,
            isExisting: false,
          });
        };

        reader.readAsDataURL(file);
      }
    },

    fetchExistingFiles(row) {
      row.files.forEach((file) => {
        this.document_files.push({
          file: file.base64,
          preview: file.base64,
          file_path: file?.file_path,
          isExisting: true,
        });
      });
    },

    removeFile(index) {
      this.document_files.splice(index, 1);
    },
    isImage(file) {
      const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"];
      const fileExtension = file.file_path.split(".").pop().toLowerCase();
      return imageExtensions.includes(`.${fileExtension}`);
    },

    isPdf(file) {
      return this.getFileExtension(file.file_path) === "pdf";
    },

    isWord(file) {
      const wordExtensions = ["doc", "docx"];
      return wordExtensions.includes(this.getFileExtension(file.file_path));
    },
    isExcel(file) {
      const excelExtensions = ["xls", "xlsx"];
      return excelExtensions.includes(this.getFileExtension(file.file_path));
    },

    getFileExtension(filePath) {
      return filePath.split(".").pop().toLowerCase();
    },

    getFileName(filePath) {
      return filePath.split("/").pop().split(".")[0];
    },

    async submitForm() {
      this.isLoading = true;
      const endpoint = this.isEditMode
        ? `/document-manage/${this.itemId}`
        : "/document-manage";

      const method = "post";

      const formData = new FormData();

      this.document_files.forEach((documentFile) => {
        if (!documentFile.isExisting) {
          formData.append("document_files[]", documentFile.file);
        }
      });

      this.document_files.forEach((documentFile) => {
        if (documentFile.isExisting) {
          formData.append("existing_files[]", documentFile.file_path);
        }
      });

      formData.append("file_name", this.file_name);
      formData.append("category_id", this.category_id);
      formData.append("exhibition_id", this.exhibition_id);

      try {
        const response = await http[method](endpoint, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$toast.success(response.data.message);
        this.$handleModal("add_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      const endpoint = `/document-manage/${this.itemId}`;
      const method = "delete";
      try {
        const response = await http[method](endpoint);
        this.$toast.success(response.data.message);
        this.$handleModal("delete_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.d-flex.flex-wrap.gap-3 {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}

.file-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 150px;
  word-wrap: break-word;
}

.preview-box {
  height: 80px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.img-thumbnail {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: 100% !important;
  width: 100% !important;
}

.static-thumbnail {
  max-width: 60px;
  max-height: 60px;
}

.file-name {
  font-size: 0.575rem;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100px;
  text-align: center;
}
.btn-primary.btn-sm {
  width: 100%;
  text-transform: uppercase;
  font-size: 0.7rem;
  padding: 0.5rem;
}
</style>
